// Peças comuns das telas fora da mesa: moldura, topo, campo do código da sala e aviso de carregamento. A marca é o
// componente Marca de packages/ui.
import { type ReactNode, useState } from 'react';
import { Marca } from '@truco6/ui/Marca';

// painel: as abas principais (Início, Perfil e Amigos), que a partir de 720 px de largura usam o contêiner único de até
// 1200 px, com 2 colunas. larga: telas com lista ou grade, até 960 px. Sem nada: a coluna de celular.
export function Tela({ children, larga = false, painel = false }: { children: ReactNode; larga?: boolean; painel?: boolean }) {
  return (
    <main className="tela">
      <div className={'coluna' + (painel ? ' painel' : larga ? ' larga' : '')}>{children}</div>
    </main>
  );
}

// marca: o símbolo no canto do topo, nas telas que levam a marca (Como jogar, Planos, campeonato, marcador).
export function Topo({ titulo, voltar, marca = false }: { titulo: string; voltar?: () => void; marca?: boolean }) {
  return (
    <header className="topo">
      {voltar && <button className="voltar" aria-label="Voltar" onClick={voltar}>‹</button>}
      <h1>{titulo}</h1>
      {marca && <Marca variante="simbolo" altura={28} className="marca-topo" />}
    </header>
  );
}

// Carregando: o símbolo, que cabe em qualquer espaço.
export function Carregando({ texto = 'Um instante...' }: { texto?: string }) {
  return (
    <Tela>
      <Marca variante="simbolo" altura={56} className="marca-carregando" />
      <p className="carregando" role="status">{texto}</p>
    </Tela>
  );
}

export function lerCodigo(texto: string): string | null {
  const limpo = texto.trim().replace(/^.*\/(s|sala)\//, '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  return /^[A-Z2-9]{6}$/.test(limpo) ? limpo : null;
}

// Aceita o código (6 letras e números) ou o link inteiro colado do WhatsApp.
export function CampoCodigo({ rotulo, aoEntrar }: { rotulo: string; aoEntrar: (codigo: string) => void }) {
  const [texto, setTexto] = useState('');
  const [erro, setErro] = useState(false);
  return (
    <form className="campo" onSubmit={(ev) => {
      ev.preventDefault();
      const c = lerCodigo(texto);
      if (c) aoEntrar(c); else setErro(true);
    }}>
      <label htmlFor="codigo">{rotulo}</label>
      <div className="dupla">
        <input id="codigo" value={texto} placeholder="Código ou link" autoComplete="off" autoCapitalize="characters" spellCheck={false}
          aria-invalid={erro} onChange={(ev) => { setTexto(ev.target.value); setErro(false); }} />
        <button className="btn2">Entrar</button>
      </div>
      {erro && <small className="erro" role="alert">O código tem 6 letras e números, como K7QX2M.</small>}
    </form>
  );
}
